import user from "../user/state";

export function getProducts(state) {
  return state.products;
}

export function getTypes(state){
  return state.types;
}

export function getUserProducts(state) {
  return state.products.filter(
    product => product.user_id === user.current_user.id
  );
}
